import { render, staticRenderFns } from "./CardMenu.vue?vue&type=template&id=1fee3d4e&scoped=true"
import script from "./CardMenu.vue?vue&type=script&lang=js"
export * from "./CardMenu.vue?vue&type=script&lang=js"
import style0 from "./CardMenu.vue?vue&type=style&index=0&id=1fee3d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fee3d4e",
  null
  
)

export default component.exports